/* eslint-disable react-hooks/exhaustive-deps */
import React, { createContext, useEffect, useState } from 'react';
import axios from 'axios';
import type { User } from './types/userTypes';
import { AUTH_URL } from './util/constants';
export const userContext = createContext<{
  user: User | undefined;
  setUser: React.Dispatch<React.SetStateAction<User | undefined>>;
  loading: boolean;
}>({
  user: undefined,
  setUser: () => {},
  loading: false,
});

type props = {
  children: React.ReactNode;
};

const UserContext = ({ children }: props) => {
  const [loading, setLoading] = useState(true);
  const [user, setUser] = useState<User | undefined>(undefined);

  async function fetchCurrrentUser() {
    setLoading(true);
    try {
      const res = await axios.get(`${AUTH_URL}/me`, {
        withCredentials: true,
      });
      setUser(res.data.User);
    } catch (err: any) {
      setUser(undefined);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    fetchCurrrentUser();
  }, []);

  return (
    <userContext.Provider value={{ user, setUser, loading }}>
      {children}
    </userContext.Provider>
  );
};

export default UserContext;
